<template>
  <!-- 广告首页 -->
  <div class="adver">
    <div class="adver_box">
      <el-card>
        <el-form :inline="true" label-width="120px" size="small" id="myform">
          <el-form-item label="页面位置">
            <el-select
              v-model="searchData.pageType"
              placeholder="请选择"
              clearable
              @change="pageChange"
            >
              <el-option
                v-for="item in pageType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="广告图片类型">
            <el-select
              placeholder="请选择"
              v-model="searchData.isHomeRotation"
              id="imgTypes"
              clearable
            >
              <el-option
                v-for="item in imgType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.fen
                }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="审核状态">
            <el-select
              v-model="searchData.examine"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in examineDas"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <div>
            <el-form-item>
              <el-button
                style="margin-left: 90px"
                type="primary"
                @click="adverSearch"
                v-if="menuPerm('floorAD:list')"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="adverAdd"
                v-if="menuPerm('floorAD:insert')"
                >添加</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="adverClear">清空</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-card>
      <el-card>
        <el-table
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          :data="adverData"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <el-table-column
            label="图片"
            prop="examineStatus"
            width="200px"
            height="200px"
          >
            <template slot-scope="{ row }">
              <div class="adver_img">
                <img :src="row.imgUrl" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="标题" prop="title"></el-table-column>
          <el-table-column label="链接" prop="linkTo" width="300px">
            <template slot-scope="{ row }">
              <span class="link_text">{{ row.linkTo }}</span>
              <el-button
                @click="copy"
                type="primary"
                class="btns"
                :data-clipboard-text="row.linkTo"
                style="margintop: 5px"
                >复制</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="开始时间" prop="startDate"></el-table-column>
          <el-table-column label="结束时间" prop="endDate"></el-table-column>
          <el-table-column label="权重" prop="sort"></el-table-column>
          <el-table-column
            label="是否过审"
            prop="examineStatus"
            width="150px"
            v-if="menuPerm('floorAD:review')"
          >
            <template slot-scope="{ row }">
           
              <el-select
                placeholder="请选择"
                v-model="row.examineStatus"
                @change="examChange(row.id, row.examineStatus)"
              >
                <el-option
                  v-for="item in examineDas"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="页面类型" prop="pageType" width="100px">
            <template slot-scope="{ row }">
              <div v-if="row.pageType == 0">房产首页</div>
              <div v-if="row.pageType == 1">房产列表页</div>
              <div v-if="row.pageType == 2">房产详情页</div>
              <div v-if="row.pageType == 3">新闻推荐页</div>
            </template>
          </el-table-column>
          <el-table-column
            label="广告图片类型"
            prop="isHomeRotation"
            width="120px"
          >
            <template slot-scope="{ row }">
              <div v-if="row.isHomeRotation == 1">轮播</div>
              <div v-if="row.isHomeRotation == 2">长条</div>
              <div v-if="row.isHomeRotation == 3">正方</div>
              <div v-if="row.isHomeRotation == 4">长方</div>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="200px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                @click="adverDel(row.id)"
                v-if="menuPerm('floorAD:delete')"
                >删除</el-button
              >
              <el-button
                type="primary"
                @click="adverEdit(row)"
                v-if="menuPerm('floorAD:update')"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
           <!-- 详情页面 -->
      <a-drawer
        title="楼盘广告详情"
        :width="980"
        :visible="visible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Detail :Detaildata="detailData" />
      </a-drawer>
    </div>
    <!-- 删除弹出框 -->
    <a-modal
      title="广告"
      :visible="delOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>确定要删除吗？</p>
    </a-modal>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import Detail from './addEdit'
export default {
  data() {
    return {
      detailData:'',
       visible: false,
      multipleSelection: [], //分页
      delOpen: false,
      delId: "", //删除的id
      pagesize: 10,
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      adverData: [], //广告的数据
      searchData: {
        isHomeRotation: "", //广告图片类型
        pageType: "", //页面位置
        examine: "", //审核状态
        // delType: "" //删除状态
      },
      //图片类型：
      imgType: [],

      //房产首页--联动
      imgType_lun: [
        {
          label: "轮播图",
          value: "1",
          fen: "（1200*675）",
        },
      ],
      //新房列表页--联动
      imgType_lie: [
        {
          label: "长条",
          value: "2",
          fen: "（1120*100）",
        },
        {
          label: "右侧-方块",
          value: "3",
          fen: "（262*336）",
        },
      ],
      //房产详情页--联动
      imgType_xiang: [
        {
          label: "顶部-长方图",
          value: "4",
          fen: "（1200*300）",
        },
        {
          label: "长条",
          value: "2",
          fen: "（1200*55）",
        },
        {
          label: "右侧方块",
          value: "3",
          fen: "（350*366）",
        },
      ],
      //网站首页--联动
      imgType_index: [
        {
          label: "顶部-长方",
          value: "4",
          fen: "（1200*470）",
        },
        {
          label: "右侧方块",
          value: "3",
          fen: "（356*430）",
        },
      ],
      //页面类型：
      pageType: [
        {
          label: "房产首页",
          value: "0",
        },
        {
          label: "房产列表页",
          value: "1",
        },
        {
          label: "房产详情页",
          value: "2",
        },
        {
          label: "新闻推荐页",
          value: "3",
        },
      ],
      //审核状态--下拉框：
      examineDas: [
        {
          label: "通过审核",
          value: "1",
        },
        {
          label: "未通过审核",
          value: "0",
        },
      ],
      //删除状态--下拉框：
      delData: [
        {
          label: "已删除",
          value: "0",
        },
        {
          label: "未删除",
          value: "1"
        }
      ],
      type:''
    };
  },
    components: {
    Detail
  },
  methods: {
       onClose() {
      this.visible = false;
      this.adverInit()
    },
        //复制文本：
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      // 　　　var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");

        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.adverInit();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.adverInit();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //审核接口：
    examChange(ids, examStatus) {
      
      this.getAxios("/floorAD/review", {
        adId: ids,
        status: examStatus,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("审核修改成功");
        } else if (res.success == false) {
          this.$message.success(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 广告的数据：
    adverInit() {
      this.postAxios("/floorAD/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        isHomeRotation: this.searchData.isHomeRotation,
        pageType: this.searchData.pageType,
        examineStatus: this.searchData.examine, //审核状态
      }).then((res) => {
        if (res.success == true) {
          this.adverData = res.content;
          this.totalCount = res.totalCount;
          // 时间戳转时间：
          this.adverData.map((i, index) => {
            if (i.sort != null && i.sort != 0) {
              var timeTrans = new Date(parseInt(i.sort) * 1000);
              let reviewTimestampsd = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });
              this.$set(this.adverData[index], `sort`, reviewTimestampsd);
            } else {
              this.$set(this.adverData[index], `sort`, "");
            }
          });
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //查询数据：
    adverSearch() {
      this.currentPage = 1;

      this.postAxios("/floorAD/list", {
        pageNum: 1,
        pageSize: 10,
        isHomeRotation: this.searchData.isHomeRotation,
        pageType: this.searchData.pageType,
        examineStatus: this.searchData.examine, //审核状态
      }).then((res) => {
        if (res.success == true) {
          this.adverData = res.content;

          this.totalCount = res.totalCount;
          // 时间戳转时间：
          this.adverData.map((i, index) => {
            if (i.sort != null && i.sort != 0) {
              var timeTrans = new Date(parseInt(i.sort) * 1000);
              let reviewTimestampsd = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });
              this.$set(this.adverData[index], `sort`, reviewTimestampsd);
            } else {
              this.$set(this.adverData[index], `sort`, "");
            }
          });
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },
    //添加广告：
    adverAdd() {
      this.$router.push({ path: "/advertisemenAdd" });
    
    },
    //清空表单：
    adverClear() {
      document.getElementById("myform").reset();
      this.searchData.isHomeRotation = "";
      this.searchData.examine = "";
      this.searchData.pageType = "";
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    //确定删除
    handleOk() {
      this.getAxios("/floorAD/delete", {
        adId: this.delId,
      }).then((res) => {
        if (res.success == true) {
          this.adverInit();
          this.$message.success("删除成功");
          this.delOpen = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }
      });
    },
    // 删除广告：
    adverDel(id) {
      this.delId = id;
      this.delOpen = true;
    },
    //修改广告：
    adverEdit(data) {
    
 
       this.visible = true;
      
       this.detailData = data;
    },

    //二级联动：
    pageChange(val) {
      switch (val) {
        case "0":
          this.imgType = this.imgType_lun;
          break;
        case "1":
          this.imgType = this.imgType_lie;
          break;
        case "2":
          this.imgType = this.imgType_xiang;
          break;
        case "3":
          this.imgType = this.imgType_index;
          break;
        default:
          this.imgType = [
            {
              label: "",
              value: "",
              fen: "",
            },
          ];
          break;
      }
    },
  },
  created() {
    this.adverInit(); //广告的数据
    
  },
};
</script>
<style scoped lang="less">
.adver {
  width: 100%;
  height: 100%;
  .adver_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .adver_img {
        width: 200px;
        height: 150px;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }
      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 10px;
        margin-left: 10px;
      }
      .link_text {
        display: block;
        width: 200px;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      /deep/ .btns {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 30px;
      }
    }

  }

}
 /deep/ .ant-drawer-content-wrapper .ant-drawer-wrapper-body {
    height: 100%;
   
    overflow-x: hidden;
}
</style>